module.exports = "<a uiSref=\"{{sref}}\" title=\"{{text}}\" class=\"button mb-10\">\n    <i class=\"fa fa-chevron-left mr-5\"></i>{{text}}\n</a>\n"